var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgL(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_47_7)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#EE6666",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.19048,
    y: 0.190476,
    width: 31.619,
    height: 31.619,
    rx: 15.8095,
    stroke: "black",
    strokeWidth: 0.380952,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-1_47_7",
    maskUnits: "userSpaceOnUse",
    x: 11.9524,
    y: 6.47607,
    width: 13,
    height: 19,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 11.9524,
    y: 6.47607,
    width: 13,
    height: 19
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2682 24.4761V6.96253H16.9818V21.4094H24.0854V24.4761H13.2682Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.2682 24.4761V6.96253H16.9818V21.4094H24.0854V24.4761H13.2682Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2682 24.4761H12.8873V24.857H13.2682V24.4761ZM13.2682 6.96253V6.58158H12.8873V6.96253H13.2682ZM16.9818 6.96253H17.3627V6.58158H16.9818V6.96253ZM16.9818 21.4094H16.6008V21.7904H16.9818V21.4094ZM24.0854 21.4094H24.4664V21.0285H24.0854V21.4094ZM24.0854 24.4761V24.857H24.4664V24.4761H24.0854ZM13.6492 24.4761V6.96253H12.8873V24.4761H13.6492ZM13.2682 7.34348H16.9818V6.58158H13.2682V7.34348ZM16.6008 6.96253V21.4094H17.3627V6.96253H16.6008ZM16.9818 21.7904H24.0854V21.0285H16.9818V21.7904ZM23.7045 21.4094V24.4761H24.4664V21.4094H23.7045ZM24.0854 24.0951H13.2682V24.857H24.0854V24.0951Z",
    fill: "black",
    mask: "url(#path-3-outside-1_47_7)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_47_7",
    x: 0.47619,
    y: 0,
    width: 35.0476,
    height: 35.0476,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.52381
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.761905
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_47_7"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_47_7",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgL);
export default __webpack_public_path__ + "static/media/L.a24cb4a5e4eaba7759747c02858db2ba.svg";
export { ForwardRef as ReactComponent };